<template>
  <!-- 260611 시안 main_typeC_00 (3): 비즈니스 신고 전용 모달 (공용 RADIO_CONTENT_MODAL 대체) -->
  <div class="biz-report-dim" @click.self="close">
    <div class="biz-report" role="dialog" aria-modal="true">
      <div class="biz-report__body">
        <div class="biz-report__head">
          <strong class="biz-report__title">신고하기</strong>
          <button type="button" class="biz-report__close" aria-label="닫기" @click="close">
            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
              <path d="M5 5 L15 15 M15 5 L5 15" fill="none" stroke="#222" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="biz-report__divider"></div>
        <p class="biz-report__subtitle">신고하려는 이유를 선택해 주세요.</p>
        <ul class="biz-report__reasons">
          <li
            v-for="(r, i) in reasons"
            :key="i"
            class="biz-report__reason"
            :class="{ active: selected === r }"
            @click="selected = r"
          >
            <svg class="biz-report__check" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
              <rect
                x="2.5" y="2.5" width="15" height="15" rx="4"
                fill="none" :stroke="selected === r ? '#30CA22' : '#959595'" stroke-width="1.3"
              />
              <path
                d="M6.3 10.2 L8.7 12.6 L13.7 7.4"
                fill="none" :stroke="selected === r ? '#30CA22' : '#959595'"
                stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
              />
            </svg>
            <span class="biz-report__label">{{ r }}</span>
          </li>
        </ul>
      </div>
      <button type="button" class="biz-report__submit" @click="onSubmit">신고하기</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { showTextModal } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, errorText } = props.data || {};

// 시안 main_typeC_00 (3) 신고 사유 5종
const reasons = [
  '중복/도배성 게시글',
  '부적절한 게시글',
  '욕설/혐오 표현이 사용됨',
  '불건전한 게시글',
  '광고/홍보 게시글'
];
const selected = ref(reasons[0]);

const onSubmit = () => {
  if (!selected.value) {
    showTextModal(errorText || '신고 사유를 선택해주세요.', '확인');
    return;
  }
  // detail.vue report()의 fnCallBack(data => data.value) 형태 유지 — 트리거 측 무수정
  if (fnCallBack) fnCallBack({ value: selected.value });
  close();
};

const close = () => {
  setTimeout(() => emits('close'), 200);
};
</script>

<style scoped>
.biz-report-dim {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.6rem;
  background: rgba(0, 0, 0, 0.5);
}
.biz-report {
  box-sizing: border-box;
  width: 100%;
  max-width: 34.3rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 3rem 2rem;
  background: #fff;
  border-radius: 1.4rem;
}
.biz-report__body {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}
.biz-report__head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1.4rem;
}
.biz-report__title {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  letter-spacing: -0.03em;
}
.biz-report__close {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  appearance: none;
}
.biz-report__divider {
  height: 1px;
  background: #cacaca;
}
.biz-report__subtitle {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 400;
  color: #000;
  letter-spacing: -0.03em;
}
.biz-report__reasons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}
.biz-report__reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
}
.biz-report__check {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
}
.biz-report__label {
  font-size: 1.4rem;
  font-weight: 400;
  color: #959595;
  letter-spacing: -0.03em;
}
.biz-report__reason.active .biz-report__label {
  font-weight: 500;
  color: #000;
}
.biz-report__submit {
  width: 100%;
  height: 5rem;
  padding: 0;
  border: 0;
  border-radius: 1rem;
  background: #30ca22;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 500;
  letter-spacing: -0.3px;
  cursor: pointer;
}
.biz-report__submit:active {
  background: #28a81c;
}
</style>
